module.exports = __webpack_public_path__ + "media/images/png/logo-b8a7182206c248c18834b12366c18723.png";